import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameAMainCharacter extends PIXI.Container {

  constructor(game) {
    super();

    let bike = new PIXI.Sprite(game.assets["main-bike"]);
    this.addChild(bike);

    this.spokes = [];
    let spoke1 = new PIXI.Sprite(game.assets["main-bike-wheel-spin"]);
    spoke1.position.x = 110;
    spoke1.position.y = 254;
    spoke1.anchor.set(0.5);
    spoke1.alpha = 0;
    this.addChild(spoke1);

    let spoke2 = new PIXI.Sprite(game.assets["main-bike-wheel-spin"]);
    spoke2.position.x = 291;
    spoke2.position.y = 254;
    spoke2.anchor.set(0.5);
    spoke2.alpha = 0;
    gsap.set(spoke2, {pixi: {rotation: "90_cw"}});
    this.addChild(spoke2);

    this.spokes.push(spoke1);
    this.spokes.push(spoke2);

    this.lines = [];
    let lineWidth = 40;

    for (let i = 0; i < 3; i++) {
      let line = new PIXI.Graphics()
        .rect(0, 0, lineWidth, 4)
        .fill(0x343B6F);

      if (i == 1) {
        line.position.x = 0 + lineWidth;
        line.position.y = 90;
      } else if (i == 2) {
        line.position.x = 34 + lineWidth;
        line.position.y = 120;
      } else if (i == 0) {
        line.position.x = 48 + lineWidth;
        line.position.y = 60;
      }

      this.lines.push(line);

      gsap.set(line, {pixi: {scaleX: 0}});

      this.addChild(line);
    }

    this.animateLoop();
  }

  animateIn() {

    gsap.to(this.lines,
      {
        pixi: {
          scaleX: -1,
        },
        duration: 0.25,
        ease: "power2.out",
        // stagger: "0.05",
        overwrite: true
      });

    gsap.to(this.spokes,
      {
        pixi: {
          alpha: 1,
        },
        duration: 0.25,
        ease: "power2.in",
        overwrite: "auto"
      });
  }

  animateLoop() {


    gsap.to(this.spokes,
      {
        pixi: {
          rotation: "+=360_cw"
        },
        duration: 1,
        repeat: -1,
        ease: "none",
      });
  }

  animateOut() {
    gsap.to(this.lines,
      {
        pixi: {
          scaleX: 0,
        },
        duration: 0.5,
        ease: "power2.out",
        overwrite: "auto"
      });

    gsap.to(this.spokes,
      {
        pixi: {
          alpha: 0,
        },
        duration: 0.5,
        ease: "power2.out",
        overwrite: "auto"
      });

  }

}
